import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { media } from '@blend/consumer-components';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';
import * as React from 'react';
import { diagnostics } from '@blend/ui-common';
import history from 'login-utils/history';
import * as creditCardForm from 'login-utils/creditCardForm';
import States from 'login-constants/states';
import * as autoLoansAPI from 'login-apis/autoLoansAPI';
import CreditCardSVG from 'login-components/Common/svg/CreditCardSVG';
import ProductCardGroup from '../ProductCardGroup/ProductCardGroup';
import { ProductCardConfig } from '../ProductCard/ProductCard';

const styles = StyleSheet.create({
  root: {
    width: 560,
    [media.mobileMedium]: {
      width: '100%',
    },
  },
});

namespace ChooseCreditCardProduct {
  export interface State {
    products: AutoService.DCSCreditCardProduct[];
  }
  export type Props = ReactRouter.RouteComponentProps<{}, {}>;
}

export class UnconnectedChooseCreditCardProduct extends React.Component<
  ChooseCreditCardProduct.Props & FormProps<DataShape, ChooseCreditCardProduct.Props, ReduxState>,
  ChooseCreditCardProduct.State
> {
  state: ChooseCreditCardProduct.State = {
    products: [],
  };

  async componentDidMount() {
    try {
      const loginAppConfig = await autoLoansAPI.getConfig();
      const products: AutoService.DCSCreditCardProduct[] = loginAppConfig.CREDIT_CARD.products;
      this.setState({ products });
    } catch (err) {
      // istanbul ignore next
      diagnostics.error(err);
    }
  }

  onSubmit = (_product: AutoService.DCSCreditCardProduct['id']) => {
    // TODO: (CL-913) States.CREDIT_CARD_FORM
    history.push(States.CREATE_ACCOUNT);
  };

  getProductCardConfigs(): ProductCardConfig[] {
    const { products } = this.state;
    return _.map(products, product => ({
      value: product.id,
      productId: product.id,
      title: product.title,
      description: product.subtitle,
      hasDetails: !!product.details,
      isDisabled: false,
      modalTitle: _.get(product, 'details.title') /* istanbul ignore next */ || product.title,
      modalContent: _.get(product, 'details.body', ''),
      modalNotes: _.get(product, 'details.footers', []),
      imageLink: product.imageLink,
    }));
  }

  render(): React.ReactNode {
    const { products } = this.state;

    // avoid render until products are populated
    if (_.isEmpty(products)) return null;

    return (
      <div className={css(styles.root)}>
        <Field
          name={creditCardForm.FIELDS.productId}
          component={ProductCardGroup}
          configs={this.getProductCardConfigs()}
          onSelect={this.onSubmit}
          defaultSVG={CreditCardSVG}
        />
      </div>
    );
  }
}

export default reduxForm<
  FormProps<DataShape, ChooseCreditCardProduct.Props, ReduxState>,
  ChooseCreditCardProduct.Props,
  ReduxState
>(creditCardForm.FORM_CONFIG)(UnconnectedChooseCreditCardProduct);
